import React from 'react';
import ToolROISection from '../../../Tools/ROICalculator/Section';

import { StyledModal } from './styles';

const ContentfulModalTool = (props) => {
  if (props?.internalName === 'ROI Calculator') {
    return (
      <StyledModal
        open={props.visible}
        width="max-content"
        onClose={() => props.closeModal(false)}
        handleClose={() => props.closeModal(false)}
      >
        <div>
          <ToolROISection {...props} />
        </div>
      </StyledModal>
    );
  }

  return null;
};

export default ContentfulModalTool;
